import { render, staticRenderFns } from "./GasLawViz.vue?vue&type=template&id=407cf59d&scoped=true"
import script from "./GasLawViz.vue?vue&type=script&lang=js"
export * from "./GasLawViz.vue?vue&type=script&lang=js"
import style0 from "./GasLawViz.vue?vue&type=style&index=0&id=407cf59d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407cf59d",
  null
  
)

export default component.exports